import { render, staticRenderFns } from "./leave-topbar.vue?vue&type=template&id=e4aa62b8&scoped=true"
import script from "./leave-topbar.vue?vue&type=script&lang=js"
export * from "./leave-topbar.vue?vue&type=script&lang=js"
import style0 from "./leave-topbar.vue?vue&type=style&index=0&id=e4aa62b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aa62b8",
  null
  
)

export default component.exports